__turbopack_context__.v({
  "className": "geist_7a8b4487-module__8dr1TG__className",
});
